<div class="recorder">
  <!-- ========================================================= -->
  <!-- Status                                                     -->
  <!-- ========================================================= -->

  <div class="status" [class.status--recording]="audioState() === 'recording'">
    <span class="status-dot"></span>

    <span>
      @switch (audioState()) { @case ('idle') { Bereit zur Aufnahme } @case
      ('recording') { Aufnahme läuft } @case ('processing') { Aufnahme wird
      verarbeitet … } @case ('recorded') { Aufnahme fertig } }
    </span>
  </div>

  <!-- ========================================================= -->
  <!-- Timer                                                      -->
  <!-- ========================================================= -->

  <div class="timer">
    {{ formatDuration(duration()) }}
  </div>

  <!-- ========================================================= -->
  <!-- Live visualizer                                            -->
  <!-- ========================================================= -->

  @if (audioState() === 'recording') {

  <div
    class="visualizer"
    [attr.aria-label]="'audio.microphoneLevel' | translate"
  >
    @for ( bar of getVisualizerBars(); track $index ) {
    <span
      class="visualizer-bar"
      [style.transform]="'scaleY(' + bar + ')'"
    ></span>
    }
  </div>

  } @else {

  <div class="visualizer visualizer--empty">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>

  }

  <!-- ========================================================= -->
  <!-- Hint                                                       -->
  <!-- ========================================================= -->

  <p class="hint">
    @switch (audioState()) { @case ('idle') { Tippe auf das Mikrofon, um eine
    Aufnahme zu starten. } @case ('recording') { Sprich jetzt. Tippe auf Stop,
    wenn du fertig bist. } @case ('processing') { Einen Moment bitte … } @case
    ('recorded') { Deine Aufnahme ist bereit. } }
  </p>

  <!-- ========================================================= -->
  <!-- Main action                                                -->
  <!-- ========================================================= -->

  <button
    type="button"
    class="record-button"
    [class.record-button--recording]="audioState() === 'recording'"
    [class.record-button--processing]="audioState() === 'processing'"
    [class.record-button--play]="audioState() === 'recorded'"
    [disabled]="audioState() === 'processing'"
    (click)="
      audioState() === 'idle'
        ? startRecording()
        : audioState() === 'recording'
        ? stopRecording()
        : audioState() === 'recorded'
        ? togglePlayback()
        : null
    "
  >
    @if (audioState() === 'idle') {

    <ion-icon class="white" name="mic" aria-hidden="true"></ion-icon>

    } @if (audioState() === 'recording') {

    <ion-icon class="white" name="square" aria-hidden="true"></ion-icon>

    } @if (audioState() === 'processing') {

    <ion-spinner></ion-spinner>

    } @if (audioState() === 'recorded') {

    <ion-icon
      [name]="isPlaying() ? 'pause' : 'play'"
      class="white"
      aria-hidden="true"
    ></ion-icon>

    }
  </button>

  <!-- ========================================================= -->
  <!-- Recorded audio actions                                     -->
  <!-- ========================================================= -->

  @if (audioState() === 'recorded') {

  <div class="actions">
    <ion-button fill="outline" (click)="recordAgain()">
      <ion-icon slot="start" name="refresh"></ion-icon>
      Neu aufnehmen
    </ion-button>

    <!--ion-button (click)="deleteRecording()" color="danger">
      <ion-icon slot="start" name="trash-outline" class="white"></ion-icon>
      Löschen
    </ion-button-->

    <ion-button (click)="analyzeRecording()" color="success">
      <ion-icon slot="start" name="sparkles-outline"></ion-icon>
      Analysieren
    </ion-button>
  </div>

  }

  <!-- ========================================================= -->
  <!-- Error                                                      -->
  <!-- ========================================================= -->

  @if (error()) {

  <div class="error">
    <ion-icon name="alert-circle-outline"></ion-icon>

    <span>
      {{ error() }}
    </span>
  </div>

  }
</div>
